import { ClassType } from "../../../types/Class";
import { delEmptyBody } from "../../../utils/axios-config";
import { CLASSES } from "../../../utils/constants";

export const deleteClass = async (data:{id: string}) => await delEmptyBody<boolean>(CLASSES + `/${data.id}`   );


